import { SIZE_OF_ARRAY_WITH_THREE_ELEMENTS } from '@/constants/common';
import { OverviewImageLink } from '@/types/models';
import { OverviewImageLinkPoint } from '../OverviewImageModal.types';
import { DEFAULT_OVERVIEW_IMAGE_LINK_POINTS } from '../OverviewImagesModal.constants';

/**
 * Returns the clickable area of the link as a polygon, in natural image coordinates.
 */
export const getOverviewImageLinkPoints = ({
  polygon,
}: Pick<OverviewImageLink, 'polygon'>): OverviewImageLinkPoint[] => {
  // valid polygon needs to have at least three points
  if (polygon.length < SIZE_OF_ARRAY_WITH_THREE_ELEMENTS) {
    return DEFAULT_OVERVIEW_IMAGE_LINK_POINTS;
  }

  return polygon.map(({ x, y }) => ({ x, y }));
};
